import React, { useEffect, useRef } from "react";
import { arrayOf, number, shape, string } from "prop-types";

import * as S from "./styled";

const FoldersForm = ({ current_folder, folders, form_authenticity_token }) => {
  const selectRef = useRef(null);
  useEffect(() => {
    if (selectRef?.current?.setAttribute) {
      selectRef.current.setAttribute(
        "se:behavior",
        "ajax_onchange_form_submitter"
      );
    }
  }, []);

  return (
    <S.Form
      acceptCharset="UTF-8"
      action="/nyc/folders/set_current_folder"
      method="post"
    >
      <input name="utf8" type="hidden" value="✓" />
      <input
        name="authenticity_token"
        type="hidden"
        value={form_authenticity_token}
      />
      <S.Select
        ref={selectRef}
        defaultValue={current_folder?.id || undefined}
        id="id"
        name="id"
      >
        {folders.map(({ folder = {} } = {}, index) => (
          <option key={folder?.id || index} value={folder?.id}>
            {folder?.name?.toUpperCase()}
          </option>
        ))}
      </S.Select>
    </S.Form>
  );
};

FoldersForm.propTypes = {
  form_authenticity_token: string,
  current_folder: shape({
    id: number
  }),
  folders: arrayOf(
    shape({
      folder: shape({
        id: number,
        name: string
      })
    })
  )
};

FoldersForm.defaultProps = {
  form_authenticity_token: "",
  current_folder: undefined,
  folders: []
};

export default FoldersForm;
